<div class="appearance-wrapper">
    <div
        class="appearance-block"
        [class.active]="separator === ETimerAppearanceSeparator.none"
        (click)="changeEvent.emit(ETimerAppearanceSeparator.none)"
    >
        <div class="time">
            <span>04</span>
            <span>06</span>
            <span>16</span>
        </div>
    </div>
    <div
        class="appearance-block"
        [class.active]="separator === ETimerAppearanceSeparator.colon"
        (click)="changeEvent.emit(ETimerAppearanceSeparator.colon)"
    >
        <div class="time">
            <span>04</span>
            <span>:</span>
            <span>06</span>
            <span>:</span>
            <span>16</span>
        </div>
    </div>
    <div
        class="appearance-block"
        [class.active]="separator === ETimerAppearanceSeparator.line"
        (click)="changeEvent.emit(ETimerAppearanceSeparator.line)"
    >
        <div class="time">
            <span>04</span>
            <span class="vertical-line"></span>
            <span>06</span>
            <span class="vertical-line"></span>
            <span>16</span>
        </div>
    </div>
</div>
